export const ATTEMPT_SSO_LOGIN = 'ATTEMPT_SSO_LOGIN';
export const ATTEMPT_MOBILE_SSO_LOGIN = 'ATTEMPT_MOBILE_SSO_LOGIN';
export const FINISH_MOBILE_SSO_LOGIN = 'FINISH_MOBILE_SSO_LOGIN';

export const ROUTE_SSO_FLOW = 'ROUTE_SSO_FLOW';
export const ROUTE_WEB_SSO_FLOW = 'ROUTE_WEB_SSO_FLOW';

const SET_SSO_LOGIN_ATTEMPT_PENDING = 'SET_SSO_LOGIN_ATTEMPT_PENDING';
const SET_MOBILE_SSO_LOGIN_ERROR = 'SET_MOBILE_SSO_LOGIN_ERROR';

// intial state object
const initialSsoLoginState = {
  orgSamlEntityId: null,
  ssoLoginAttemptPending: false,
  mobileSsoLoginError: ''
};

export const ssoLoginReducer = (ssoLoginState = initialSsoLoginState, action = null) => {
  switch (action && action.type) {
    // here are actions which *only* want sagas
    case ATTEMPT_SSO_LOGIN:
    case ROUTE_SSO_FLOW:
    case ROUTE_WEB_SSO_FLOW:
    case ATTEMPT_MOBILE_SSO_LOGIN:
    case FINISH_MOBILE_SSO_LOGIN:
    default:
      return ssoLoginState;

    case SET_SSO_LOGIN_ATTEMPT_PENDING:
      return {
        ...ssoLoginState,
        ssoLoginAttemptPending: action.payload.ssoLoginAttemptPending
      };
    case SET_MOBILE_SSO_LOGIN_ERROR:
      return {
        ...ssoLoginState,
        mobileSsoLoginError: action.payload.mobileSsoLoginError
      };
  }
};

//******************************
export const ssoLoginActions = {
  routeSsoFlow: (queryParams) => ({ type: ROUTE_SSO_FLOW, payload: { queryParams: queryParams } }),
  routeWebSsoFlow: (queryParams) => ({ type: ROUTE_WEB_SSO_FLOW, payload: { queryParams: queryParams } }),
  attemptMobileSsoLogin: (queryParams) => ({ type: ATTEMPT_MOBILE_SSO_LOGIN, payload: { queryParams: queryParams } }),
  finishMobileSsoLogin: (mobileSSOLoginData) => ({
    type: FINISH_MOBILE_SSO_LOGIN,
    payload: { mobileSSOLoginData: mobileSSOLoginData }
  }),
  attemptSsoLogin: (location) => ({ type: ATTEMPT_SSO_LOGIN, payload: { location: location } }),
  setSsoLoginAttemptPending: (isPending) => ({
    type: SET_SSO_LOGIN_ATTEMPT_PENDING,
    payload: { ssoLoginAttemptPending: isPending }
  }),
  setMobileSsoLoginError: (error) => ({
    type: SET_MOBILE_SSO_LOGIN_ERROR,
    payload: { mobileSsoLoginError: error }
  })
};

//******************************
export const ssoLoginSelectors = {
  orgSamlEntityId: (state) => state.ssoLogin.orgSamlEntityId,
  ssoLoginAttemptPending: (state) => state.ssoLogin.ssoLoginAttemptPending,
  mobileSsoLoginError: (state) => state.ssoLogin.mobileSsoLoginError
};



// WEBPACK FOOTER //
// ./src/modules/login/reducer/sso-login-reducer.js